<template>
    <div>
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-card :max-width="($vuetify.breakpoint.mdAndUp) ? '430px' : '380px'" flat
                :class="($vuetify.breakpoint.xsOnly) ? 'px-5' : ''">
                <v-form name="formLogin" v-model="valid" @submit.prevent="loguear()">
                    <v-row class="d-flex flex-row justify-center align-center">
                        <v-col cols="12" md="12" class="font-weight-regular primary--text text-h5">
                            INICIAR SESIÓN
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex flex-column">
                            <ValidationProvider name="nroafiliado" rules="required|positive|numeric|between:1,199999"
                                v-slot="v">
                                <v-text-field outlined type="number" @keydown="preventArrowKeys" ref="afi"
                                    :error-messages="v.errors[0]" hide-spin-buttons v-model.number="nroafi"
                                    label="Nº afiliado/a"></v-text-field>
                            </ValidationProvider>
                            <ValidationProvider name="Contraseña" rules="required" v-slot="v">
                                <v-text-field outlined name="Contraseña" v-model="password" :value="password"
                                    label="Contraseña" :error-messages="v.errors[0]"
                                    :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" @click:append="value = !value"
                                    :type="value ? 'password' : 'text'" @input="_ => password = _">
                                </v-text-field>
                            </ValidationProvider>
                            <div class="text-center" v-if='getCantidadErroresLogin > 2 || flagCaptchaRequerido'>
                                <vue-turnstile :key="componentKey" :autoReset='true' theme="light" :siteKey="siteKey"
                                    @verified="getToken($event)" />
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="text-center justify-center py-0">
                        <v-col cols="12" md="12" class="ma-0 py-0">
                            <v-btn elevation="0"
                                :disabled="(getCantidadErroresLogin > 3 || flagCaptchaRequerido) ? (invalid || !token) : invalid"
                                @keyup.enter="loguear()" :loading="loading" class="pa-6 rounded-lg" x-large block
                                type="submit" color="primary lighten-1">
                                Ingresar
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="12" class="pt-3">
                            <v-btn @click="irARecuperaPass" class="font-weight-regular text-capitalize"
                                :class="($vuetify.breakpoint.xsOnly) ? 'text-body-2' : 'text-body-1'" text
                                color="primary">
                                Nuevo usuario / Recuperar contraseña
                            </v-btn>
                        </v-col>
                        <v-divider class="my-1 mx-5"></v-divider>
                        <v-col cols="12" md="12">
                            <v-btn class="font-weight-bold text-capitalize text-body-2" text color="primary"
                                @click="goTo('https://www.cajapsipba.org.ar/tutoriales.asp')">
                                Más información
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="12" v-if="!$vuetify.breakpoint.mdAndUp">
                            <FabRedesSociales :nonStyle="true" :horizontal="false" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </ValidationObserver>
        <DialogoConfirmar ref="dialogoForzar" :msg="msg" msgAceptar="Si, continuar" msgCancelar="Cancelar" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import '@/validation.js';
import VueTurnstile from '@gaviti/vue-turnstile';
import FabRedesSociales from '@/components/fabs/FabRedesSociales.vue';
import DialogoConfirmar from '@/components/dialogos/DialogoConfirmar.vue';

export default {
    name: 'FormLogin',
    components: {
        ValidationProvider,
        ValidationObserver,
        VueTurnstile,
        FabRedesSociales,
        DialogoConfirmar,
    },
    data() {
        return {
            loading: false,
            nroafi: '',
            password: '',
            valid: true,
            msg: 'Ya inciaste sesión en otro dispositivo o navegador. Si continuás, se cerrará esa sesión.',
            value: true,
            token: null,
            siteKey: process.env.VUE_APP_TURNSTILE_SITEKEY || '0x4AAAAAAALfPrTf0FZmBPRX',
            componentKey: 0,
            noMostrarBotonLogin: false,
        };
    },
    mounted() {
        this.$refs.afi.focus();
    },
    computed: {
        ...mapGetters('auth', ['getCantidadErroresLogin', 'flagCaptchaRequerido']),
    },
    methods: {
        ...mapActions('auth', ['login']),

        loguear(forzar = false) {
            this.loading = true;
            this.$refs.observer.validate().then(result => {
                if (result) {
                    if ((this.getCantidadErroresLogin > 2 || this.flagCaptchaRequerido) && this.token === null) {
                        this.$store.state.snackbar = {
                            show: true,
                            text: 'Debe completar el Captcha!',
                            color: 'red',
                        };
                        this.noMostrarBotonLogin = true;
                        this.loading = false;
                    } else {
                        // Widget visible en este intento -> el token Turnstile es de
                        // un solo uso: sea cual sea el resultado, hay que resetearlo
                        // y forzar un re-render del widget para el proximo intento
                        // consiga un token genuinamente nuevo (ver AD-10 del diseño).
                        const requeriaCaptcha = this.getCantidadErroresLogin > 2 || this.flagCaptchaRequerido;
                        const payload = { nroafi: this.nroafi, password: this.password, captcha: this.token }
                        if (forzar) payload.forzar = true
                        this.$store.dispatch('auth/login', payload)
                            .then(() => {
                                this.nroafi = '';
                                this.password = '';
                                this.$refs.afi.focus();
                                this.loading = false;
                                if (requeriaCaptcha) {
                                    this.token = null;
                                    this.forceRerender();
                                }
                            })
                            .catch(async (error) => {
                                this.loading = false;
                                if (requeriaCaptcha) {
                                    this.token = null;
                                    this.forceRerender();
                                }
                                if (error.response?.status === 409 && error.response.data?.errorCode === 'SESSION_ALREADY_ACTIVE') {
                                    const confirmo = await this.$refs.dialogoForzar.abrirDialogo()
                                    if (confirmo) {
                                        this.loguear(true)
                                    }
                                } else {
                                    console.log('Error al intentar ingresar');
                                }
                            });
                    }
                } else {
                    this.loading = false;
                }
            });
        },
        forceRerender() {
            this.componentKey += 1;
        },
        getToken(e) {
            this.token = e;
            this.noMostrarBotonLogin = false;
        },
        irARecuperaPass() {
            this.$router.push('/RecuperarPassword').catch(() => { });
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        goTo(url) {
            window.open(url, '_blank');
        },
    },
};
</script>
